import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import NavRoutes from "./route";

// Create a custom element with your desired ID
const customRootElement = document.createElement("div");
customRootElement.id = "krunk.ai-chatbot";
document.body.appendChild(customRootElement);

const root = ReactDOM.createRoot(customRootElement);
root.render(
  <BrowserRouter>
    <NavRoutes />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
